import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReasonNav from '../components/reason/ReasonNav';
import ReasonFooter from '../components/reason/ReasonFooter';
import { Link } from '../components/Link';
import { SKILLS, getSkillById } from '../data/hiscoreSkills';
import { BOSSES, getBossById } from '../data/hiscoreBosses';
import './HiscoresPage.css';

import overallIcon from '../images/hiscore/skill/overall.png';
import abyssalSireIcon from '../images/hiscore/boss/abyssalsire.png';
import searchIcon from '../images/articles/search-icon.svg';
import rank1 from '../images/hiscore/rank/1.png';
import rank2 from '../images/hiscore/rank/2.png';
import rank3 from '../images/hiscore/rank/3.png';
import rank4 from '../images/hiscore/rank/4.png';
import rank5 from '../images/hiscore/rank/5.png';
import rank6 from '../images/hiscore/rank/6.png';
import rank7 from '../images/hiscore/rank/7.png';
import rank8 from '../images/hiscore/rank/8.png';
import mode1 from '../images/hiscore/mode/1.png';
import mode2 from '../images/hiscore/mode/2.png';
import mode3 from '../images/hiscore/mode/3.png';
import mode4 from '../images/hiscore/mode/4.png';
import mode5 from '../images/hiscore/mode/5.png';

const RANK_ICONS = { 1: rank1, 2: rank2, 3: rank3, 4: rank4, 5: rank5, 6: rank6, 7: rank7, 8: rank8 };
const MODE_ICONS = { 1: mode1, 2: mode2, 3: mode3, 4: mode4, 5: mode5 };

const MOCK_SKILL_DATA = [
  { rank: 1, username: 'Detail', level: 2277, experience: 11500000000, donatorRank: 8, gameMode: 0 },
  { rank: 2, username: 'Daley', level: 2277, experience: 11500000000, donatorRank: 8, gameMode: 0 },
  { rank: 3, username: 'K O O K I E', level: 2277, experience: 11500000000, donatorRank: 7, gameMode: 0 },
  { rank: 4, username: 'Nois', level: 2277, experience: 11500000000, donatorRank: 6, gameMode: 0 },
  { rank: 5, username: 'Ruru', level: 2277, experience: 11500000000, donatorRank: 6, gameMode: 0 },
  { rank: 6, username: 'Bustable', level: 2277, experience: 11500000000, donatorRank: 5, gameMode: 0 },
  { rank: 7, username: 'Fader', level: 2277, experience: 11500000000, donatorRank: 5, gameMode: 0 },
  { rank: 8, username: 'Death2', level: 2277, experience: 11500000000, donatorRank: 4, gameMode: 0 },
  { rank: 9, username: 'Voidmaker', level: 2277, experience: 11500000000, donatorRank: 4, gameMode: 1 },
  { rank: 10, username: 'Fercho', level: 2277, experience: 11500000000, donatorRank: 3, gameMode: 0 },
  { rank: 11, username: 'Iron Thvg69', level: 2277, experience: 11500000000, donatorRank: 3, gameMode: 1 },
  { rank: 12, username: 'Tod Flanders', level: 2277, experience: 11500000000, donatorRank: 2, gameMode: 0 },
  { rank: 13, username: 'Rexx', level: 2277, experience: 11500000000, donatorRank: 2, gameMode: 0 },
  { rank: 14, username: 'Cranck', level: 2277, experience: 11500000000, donatorRank: 1, gameMode: 0 },
  { rank: 15, username: 'Xiane', level: 2277, experience: 11500000000, donatorRank: 1, gameMode: 0 },
  { rank: 16, username: 'Xestica', level: 2277, experience: 11500000000, donatorRank: 0, gameMode: 0 },
  { rank: 17, username: 'Helicopter', level: 2277, experience: 11500000000, donatorRank: 0, gameMode: 2 },
  { rank: 18, username: 'Curmudgeon', level: 2277, experience: 11500000000, donatorRank: 0, gameMode: 0 },
  { rank: 19, username: 'J E S S', level: 2277, experience: 11500000000, donatorRank: 0, gameMode: 0 },
  { rank: 20, username: 'Mip', level: 2277, experience: 11500000000, donatorRank: 0, gameMode: 0 },
  { rank: 21, username: 'Jerboa', level: 2277, experience: 11500000000, donatorRank: 0, gameMode: 0 },
  { rank: 22, username: 'Faladorable', level: 2277, experience: 11500000000, donatorRank: 0, gameMode: 0 },
  { rank: 23, username: 'Donderblitz', level: 2277, experience: 11500000000, donatorRank: 0, gameMode: 0 },
  { rank: 24, username: 'Gim Edo', level: 2277, experience: 11500000000, donatorRank: 0, gameMode: 2 },
  { rank: 25, username: 'Gim Daley', level: 2277, experience: 11500000000, donatorRank: 0, gameMode: 2 },
];

const MOCK_BOSS_DATA = [
  { rank: 1, username: 'Death2', kills: 6200, donatorRank: 4, gameMode: 0 },
  { rank: 2, username: 'Fluux', kills: 2234, donatorRank: 6, gameMode: 0 },
  { rank: 3, username: 'Xiane', kills: 2011, donatorRank: 1, gameMode: 0 },
  { rank: 4, username: 'Iron Thvg69', kills: 1574, donatorRank: 3, gameMode: 1 },
  { rank: 5, username: 'Digisky', kills: 1521, donatorRank: 0, gameMode: 0 },
  { rank: 6, username: 'Xestica', kills: 1500, donatorRank: 0, gameMode: 0 },
  { rank: 7, username: 'Joabb', kills: 1441, donatorRank: 0, gameMode: 0 },
  { rank: 8, username: 'Gim Gigi', kills: 1380, donatorRank: 0, gameMode: 2 },
  { rank: 9, username: 'Mirai', kills: 1337, donatorRank: 5, gameMode: 0 },
  { rank: 10, username: 'J E S S', kills: 1318, donatorRank: 0, gameMode: 0 },
  { rank: 11, username: 'Don Kee', kills: 1278, donatorRank: 0, gameMode: 0 },
  { rank: 12, username: 'Pkedbyzig', kills: 1267, donatorRank: 0, gameMode: 0 },
  { rank: 13, username: 'Noobtube', kills: 1234, donatorRank: 0, gameMode: 0 },
  { rank: 14, username: '3u', kills: 1200, donatorRank: 0, gameMode: 0 },
  { rank: 15, username: 'Gim 3', kills: 1150, donatorRank: 0, gameMode: 2 },
  { rank: 16, username: 'Whizzop', kills: 1145, donatorRank: 0, gameMode: 0 },
  { rank: 17, username: 'Duramax', kills: 1126, donatorRank: 0, gameMode: 0 },
  { rank: 18, username: 'Atef', kills: 1106, donatorRank: 0, gameMode: 0 },
  { rank: 19, username: 'Bomboclat30', kills: 1102, donatorRank: 0, gameMode: 0 },
  { rank: 20, username: 'Dan Gleebles', kills: 1100, donatorRank: 0, gameMode: 0 },
  { rank: 21, username: 'Bustable', kills: 1093, donatorRank: 5, gameMode: 0 },
  { rank: 22, username: 'Bam Bam', kills: 1076, donatorRank: 0, gameMode: 0 },
  { rank: 23, username: 'Sc90', kills: 1073, donatorRank: 0, gameMode: 0 },
  { rank: 24, username: 'Tuffern', kills: 1071, donatorRank: 0, gameMode: 0 },
  { rank: 25, username: 'Jerboa', kills: 1064, donatorRank: 0, gameMode: 0 },
];

const XP_MODES = [
  { value: -1, label: 'Every Experience' },
  { value: 0, label: 'Easy' },
  { value: 1, label: 'Intermediate' },
  { value: 2, label: 'Hard' },
  { value: 3, label: 'Extreme' },
];

const GAME_MODES = [
  { value: -1, label: 'Every Mode' },
  { value: 0, label: 'Normal' },
  { value: 1, label: 'Ironman' },
  { value: 2, label: 'Group Ironman' },
  { value: 3, label: 'Hardcore Ironman' },
  { value: 4, label: 'Hardcore Group Ironman' },
  { value: 5, label: 'Ultimate Ironman' },
];

const formatNumber = (num) => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

const getSkillImagePath = (imageName) => {
  try {
    return require(`../images/hiscore/skill/${imageName}`);
  } catch {
    return overallIcon;
  }
};

const getBossImagePath = (imageName) => {
  try {
    return require(`../images/hiscore/boss/${imageName}`);
  } catch {
    return abyssalSireIcon;
  }
};

function HiscoresPage() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [xpMode, setXpMode] = useState(-1);
  const [gameMode, setGameMode] = useState(-1);

  const isBossPage = location.pathname.includes('boss-hiscores');

  const queryParams = new URLSearchParams(location.search);
  const skillId = queryParams.get('skillId') || 'overall';
  const bossId = parseInt(queryParams.get('bossId') || '1', 10);

  const currentSkill = getSkillById(skillId);
  const currentBoss = getBossById(bossId);

  useEffect(() => {
    const root = document.getElementById('root');
    const prevRootBg = root?.style.backgroundColor;
    if (root) root.style.backgroundColor = '#111013';
    return () => {
      document.body.style.overflow = '';
      if (root) root.style.backgroundColor = prevRootBg || '';
    };
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
  }, [menuOpen]);

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      window.location.href = `/hiscores/${encodeURIComponent(searchTerm.trim())}`;
    }
  };

  const buildSkillLink = (id) => `/hiscores?skillId=${id}&xpMode=${xpMode}&gameMode=${gameMode}`;
  const buildBossLink = (id) => `/hiscores/boss-hiscores?bossId=${id}&xpMode=${xpMode}&gameMode=${gameMode}`;

  return (
    <div className={`reason-page hiscores-page${menuOpen ? ' menu-open' : ''}`}>
      <ReasonNav activePage="hiscores" menuOpen={menuOpen} setMenuOpen={setMenuOpen} />

      <div className="container mx-auto hiscore-table">
        <h2 style={{ textAlign: 'center', marginBottom: 50 }}>
          {isBossPage ? 'Boss Hiscores' : 'Hiscores'}
        </h2>

        <div
          className="mx-auto secondary-container tab-toggle-container"
          style={{ display: 'flex', width: 480, padding: 5, marginBottom: 40, justifyContent: 'center' }}
        >
          <Link
            to="/hiscores"
            className="button third small"
            style={{
              display: 'flex',
              alignItems: 'center',
              ...(!isBossPage ? { background: '#161518' } : {}),
            }}
          >
            <img src={overallIcon} alt="overall icon" />
            Skills Hiscores
          </Link>
          <Link
            to="/hiscores/boss-hiscores"
            className="button third small"
            style={{
              display: 'flex',
              alignItems: 'center',
              ...(isBossPage ? { background: '#161518' } : {}),
            }}
          >
            <img src={abyssalSireIcon} alt="boss icon" />
            Boss Hiscores
          </Link>
        </div>

        <div className="main-hiscore-container">
          <div className="top-section-hiscores">
            <form className="search-bar" onSubmit={handleSearch}>
              <input
                type="text"
                className="form-text form-control"
                placeholder="Search for a user..."
                maxLength={16}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <button type="submit" className="search-icon button third">
                <img src={searchIcon} alt="search icon" />
              </button>
            </form>

            <div className="xp-mode">
              <select
                className="form-control"
                value={xpMode}
                onChange={(e) => setXpMode(parseInt(e.target.value, 10))}
              >
                {XP_MODES.map((mode) => (
                  <option key={mode.value} value={mode.value}>
                    {`XP Mode: ${mode.label}`}
                  </option>
                ))}
              </select>
            </div>

            <div className="game-mode">
              <select
                className="form-control"
                value={gameMode}
                onChange={(e) => setGameMode(parseInt(e.target.value, 10))}
              >
                {GAME_MODES.map((mode) => (
                  <option key={mode.value} value={mode.value}>
                    {`Gamemode: ${mode.label}`}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="skills-menu">
            <div className="secondary-container">
              <p className="secondary-title">{isBossPage ? 'Bosses' : 'Skills'}</p>
              {isBossPage ? (
                BOSSES.map((boss) => (
                  <Link
                    key={boss.id}
                    to={buildBossLink(boss.id)}
                    className={`skill-link${boss.id === currentBoss.id ? ' active' : ''}`}
                  >
                    <img
                      src={getBossImagePath(boss.image)}
                      alt={`${boss.name} Logo`}
                      className="skill-logo"
                    />
                    <span>{boss.name}</span>
                  </Link>
                ))
              ) : (
                SKILLS.map((skill) => (
                  <Link
                    key={skill.id}
                    to={buildSkillLink(skill.id)}
                    className={`skill-link${skill.id === currentSkill.id ? ' active' : ''}`}
                  >
                    <img
                      src={getSkillImagePath(skill.image)}
                      alt={`${skill.name} Logo`}
                      className="skill-logo"
                    />
                    <span>{skill.name}</span>
                  </Link>
                ))
              )}
            </div>
          </div>

          <div className="hiscore-table-area">
            <div className="secondary-container">
              <p className="secondary-title">
                <img
                  src={isBossPage ? getBossImagePath(currentBoss.image) : getSkillImagePath(currentSkill.image)}
                  alt={isBossPage ? currentBoss.name : currentSkill.name}
                />
                {isBossPage ? `${currentBoss.name} Hiscores` : `${currentSkill.name} Hiscores`}
              </p>

              <table>
                <thead>
                  <tr>
                    <th>Rank</th>
                    <th>Username</th>
                    {isBossPage ? (
                      <th>Kills</th>
                    ) : (
                      <>
                        <th>Level</th>
                        <th>Experience</th>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {(isBossPage ? MOCK_BOSS_DATA : MOCK_SKILL_DATA).map((row, index) => (
                    <tr key={index}>
                      <td>{row.rank}</td>
                      <td>
                        <div className="username-cell">
                          {row.donatorRank > 0 && RANK_ICONS[row.donatorRank] && (
                            <img
                              src={RANK_ICONS[row.donatorRank]}
                              className="rank-icon"
                              alt=""
                            />
                          )}
                          {row.gameMode > 0 && MODE_ICONS[row.gameMode] && (
                            <img
                              src={MODE_ICONS[row.gameMode]}
                              className="mode-icon"
                              alt=""
                            />
                          )}
                          <Link to={`/hiscores/${encodeURIComponent(row.username)}`}>
                            {row.username}
                          </Link>
                        </div>
                      </td>
                      {isBossPage ? (
                        <td>{formatNumber(row.kills)}</td>
                      ) : (
                        <>
                          <td>{formatNumber(row.level)}</td>
                          <td>{formatNumber(row.experience)}</td>
                        </>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className="hiscore-pagination">
                <Link to="#" className="button secondary">
                  Next Page
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ReasonFooter />
    </div>
  );
}

export default HiscoresPage;
